const FormSubHeading = ({data, extraClassNames}) => {
     return (    
          <div className="my-2">                
          <span className={`text-gray-500 font-semibold uppercase text-xs bg-gray-100 dark:bg-gray-900 rounded px-2 py-1 ${extraClassNames}`}>
          {data}
          </span>
          </div>
          )
}

export default FormSubHeading